import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBuilder } from '../api-builder/api/api-builder';
import { AppConfigService } from '../api-builder/config/app-config.service';
import { HttpRequestMethods } from '../api-builder/models/api.constants';
import { HttpHeadersPayload } from '../api-builder/models/common.interfaces';
import { Config } from '../data-models/config.interfaces';
import { handleError } from '../error/error.utils';
import {
  EndpointKey,
  IDP_APP,
  Libraries
} from './constants/static-qr-code.constants';
import {
  StaticQrCodeRequest,
  StaticQrCodeResponse
} from './interfaces/static-qr-code.interface';

@Injectable({
  providedIn: 'root'
})
export class StaticQrCodeService {
  _errorHandler = handleError.bind(this);

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  generateStaticQrCode = (
    params: StaticQrCodeRequest,
    apiKey?: string
  ): Observable<StaticQrCodeResponse> => {
    return new ApiBuilder<StaticQrCodeRequest, StaticQrCodeResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.FLOW_CODE_URL)
      .method(HttpRequestMethods['GET_HEADERS'])
      .timeOut(10000)
      .httpHeaders(this.getApiKeyHeader(apiKey))
      .queryParams(`?${this.convertToQueryParams(params)}`)
      .errorHandler(this._errorHandler)
      .library(Libraries.STATIC_QR_CODE)
      .withCredentials(true)
      .create();
  };

  getApiKeyHeader(apiKey?: string): HttpHeadersPayload {
    const config: Config = this.appConfig.getConfig('COMMON');
    const apiKeyValue = apiKey ?? config['FLOW_CODE_API_KEY'];
    return { apikey: apiKeyValue };
  }

  convertToQueryParams(request: StaticQrCodeRequest): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(request)) {
      if (value !== null && value !== undefined) {
        params = params.set(key, value.toString());
      }
    }
    return params;
  }
}
